import {Component, Input, OnInit} from '@angular/core';
import {PartnerSummaryModel} from '../../../api/model/partnerSummary.model';
import {DialogController} from '../../../../../common/dialog/dialogController';
import {
  PartnerSimilarPartnerViewDialogComponent,
  PartnerSimilarPartnerViewDialogInput
} from '../partner-similar-partner-view-dialog/partner-similar-partner-view-dialog.component';

@Component({
  selector: 'app-partner-similar-partner-summary-field',
  templateUrl: './partner-similar-partner-summary-field.component.html',
  styleUrls: [ './partner-similar-partner-summary-field.component.scss']
})
export class PartnerSimilarPartnerSummaryFieldComponent implements OnInit {

  @Input() partnerSummary: PartnerSummaryModel;
  constructor(private dialogController: DialogController) { }

  ngOnInit(): void {
  }

  clicked() {
    const input: PartnerSimilarPartnerViewDialogInput = {
      partnerSummary: this.partnerSummary
    };
    this.dialogController.open(PartnerSimilarPartnerViewDialogComponent, input, {
      title: 'Doublons potentiels'
    });
  }
}
